module.exports = __webpack_public_path__ + "img/04.f7cd0dd7.jpg";